import { useState } from "react";

export const useEditMode = (initialData) => {
  const [isEditing, setIsEditing] = useState(false);
  const [changes, setChanges] = useState({});

  const startEditing = () => {
    setIsEditing(true);
    setChanges({});
  };

  const handleChange = (field, value) => {
    setChanges((prev) => ({ ...prev, [field]: value }));
  };

  const saveChanges = () => {
    setIsEditing(false);
    return { ...initialData, ...changes };
  };

  const cancelEditing = () => {
    setIsEditing(false);
    setChanges({});
  };

  return {
    isEditing,
    changes,
    startEditing,
    handleChange,
    saveChanges,
    cancelEditing,
  };
};
